/**
 * Searches for a string within a string by first splitting the query string by white space and then searching
 * for each word in the query string in the search string.
 */
export default function stringApplySearch(
  searchIn: string | string[] | null | undefined,
  searchFor: string | undefined,
  exact?: boolean,
): boolean {
  if (!searchFor) {
    return true;
  }

  searchIn = Array.isArray(searchIn) ? searchIn.join(" ") : searchIn;

  if (!searchIn || typeof searchIn !== "string") {
    return false;
  }

  if (exact) {
    return searchIn === searchFor;
  }

  const searchInLower = searchIn.toLocaleLowerCase();

  return searchFor
    .toLocaleLowerCase()
    .split(/\s/) // whitespace regex
    .every((query) => searchInLower.includes(query));
}
